import React from 'react';
import TradePageGrid from './TradePageGrid';

const TradePageGridAndCustomiser = () => {
	return (
		<div className="flex h-full w-full flex-col">
			<TradePageGrid />
		</div>
	);
};

export default TradePageGridAndCustomiser;
